import MagnificationButtons from "./MagnificationButtons";
export default MagnificationButtons;
